import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Container, Segment, Button } from 'semantic-ui-react';
import homeSVG from '@plone/volto/icons/home.svg';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import {
  canReadProdukte,
  canReadRezepte,
  canReadRohstoffe,
  hasBenutzerUiAccess,
  hasManagementUiAccess,
  selectPermissions,
} from '../../helpers/permissions';

/**
 * Top navigation for the Rezeptdatenbank. Buttons are shown based on
 * the caller's table-level read / UI-access rights exposed by
 * @vist_permissions — see helpers/permissions.js and the backend
 * permissions_config module for the exact role matrix.
 */
const NavHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const permissions = useSelector(selectPermissions);

  const buttons = [
    {
      label: 'Rohstoffe',
      path: '/controlpanel/rezeptdatenbank/rohstoffe',
      visible: canReadRohstoffe(permissions),
    },
    {
      label: 'Rezepte',
      path: '/controlpanel/rezeptdatenbank/rezepte',
      visible: canReadRezepte(permissions),
    },
    {
      label: 'Produkte',
      path: '/controlpanel/rezeptdatenbank/produkte',
      visible: canReadProdukte(permissions),
    },
    {
      label: 'Bezüge',
      path: '/controlpanel/rezeptdatenbank/bezuege',
      visible: hasManagementUiAccess(permissions),
    },
    {
      label: 'Benutzer',
      path: '/controlpanel/rezeptdatenbank/benutzer',
      visible: hasBenutzerUiAccess(permissions),
    },
  ];

  const allowedButtons = buttons.filter((button) => button.visible);

  return (
    <Container className="navHeader">
      <Segment className="primary">
        <div className="navHeader">
          <Button
            onClick={() => history.push('/controlpanel/rezeptdatenbank')}
            disabled={location.pathname === '/controlpanel/rezeptdatenbank'}
          >
            <Icon fitted name={homeSVG} />
            Startseite
          </Button>
          {allowedButtons.map((button, index) => (
            <Button
              key={index}
              onClick={() => history.push(button.path)}
              disabled={location.pathname === button.path}
            >
              {button.label}
            </Button>
          ))}
        </div>
      </Segment>
    </Container>
  );
};

export default NavHeader;
